import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementOptionGroup } from '@/pages/menu-managements/option-groups/service';
import { MenuManagementBrandOptionGroupService } from '@/services/BrandOptionGroup/MenuManagementOptionGroupService';
import { MenuManagementListQueryParams } from '@/services/Service/MenuManagementList';

export type MenuManagementBrandOptionGroupListParams =
  MenuManagementListQueryParams;

export type BrandOptionGroupListResponse = {
  brand_option_groups: MenuManagementOptionGroup[];
  count: number;
};

export const useMenuManagementBrandOptionGroupList = async (
  params: MenuManagementBrandOptionGroupListParams
): Promise<BrandOptionGroupListResponse> => {
  const menuManagementBrandOptionGroupService =
    new MenuManagementBrandOptionGroupService(getClient());
  try {
    const res = await menuManagementBrandOptionGroupService.list(params);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
